import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
      minHeight: 200
    },
    header: {
      marginBottom: theme.spacing(2)
    },
    filtersBox: {
      marginBottom: theme.spacing(3),
      padding: theme.spacing(2, 0)
    },
    table: {
      marginTop: theme.spacing(2)
    },
    tableHeader: {
      background: colors.defaultGrey
    },
    collapseCell: {
      paddingBottom: 0,
      paddingTop: 0
    },
    detailsContainer: {
      padding: theme.spacing(2)
    },
    chartCard: {
      padding: theme.spacing(2),
      marginTop: theme.spacing(2)
    },
    chartHeader: {
      marginBottom: theme.spacing(2)
    },
    tableRowClickable: {
      cursor: 'pointer'
    }
  })
);
